import { buildComponent, type ComponentElement } from '#components'
import { z } from 'zod'

const baseValidationSchema = z.object({
  email: z.string().email({ message: 'Please input a valid email' })
})

const KlaviyoForm = buildComponent({
  name: 'klaviyo-form',
  onConstructed() {},
  onConnected(component) {
    const formElement = component.querySelector('.js-klaviyo-form')

    formElement?.addEventListener('submit', (event) => onFormSubmit(component, event))
  },
  onDisconnected(component) {
    const formElement = component.querySelector('.js-klaviyo-form')

    formElement?.removeEventListener('submit', (event) => onFormSubmit(component, event))
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'klaviyo-form': typeof KlaviyoForm
  }
}

function showError(errorMessageEl: HTMLElement | null, message: string | null) {
  if (errorMessageEl instanceof HTMLElement) {
    errorMessageEl.innerHTML = message || ''
  }
}

function showSuccess(isSuccessful: boolean, formElement: HTMLFormElement, successMessageEl: HTMLElement | null) {
  successMessageEl?.toggleAttribute('hidden', !isSuccessful)

  if (isSuccessful && formElement) {
    formElement.classList.add('tw-hidden')
  }
}

async function subscribeToKlaviyo(email: string, listId: string) {
  const klaviyoUrl = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe'
  const formData = new URLSearchParams()

  formData.append('g', listId)
  formData.append('email', email)

  const response = await fetch(klaviyoUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: formData.toString()
  })
  const data = await response.json()

  return data
}

async function onFormSubmit(component: ComponentElement, event: Event) {
  event.preventDefault()

  const formElement = event.target as HTMLFormElement
  const klaviyoListId = component.getAttribute('data-list-id') as string
  const emailField = component.querySelector('input[type="email"]') as HTMLInputElement
  const successMessageEl = component.querySelector('.js-success-message') as HTMLElement
  const errorMessageEl = component.querySelector('.js-error-message') as HTMLElement
  const emailData = { email: emailField.value }

  try {
    baseValidationSchema.parse(emailData)
    showError(errorMessageEl, '')
    emailField.classList.remove('is-error')

    const data = await subscribeToKlaviyo(emailField.value, klaviyoListId)

    if (data.success) {
      showSuccess(true, formElement, successMessageEl)
    } else {
      const message = `${data.errors[0] || 'Something went wrong.'} Please try again later.`

      showError(errorMessageEl, message)
    }
  } catch (e) {
    if (errorMessageEl && e instanceof z.ZodError) {
      if (errorMessageEl) {
        emailField.classList.add('is-error')

        const message = e.errors.map((error) => error.message).join(', ')

        showError(errorMessageEl, message)
      }

      return
    }
  }
}
